import Commerce from "@chec/commerce.js";

export const commerce = new Commerce(
  'pk_31013264c28920a0d0e1d5646bcabd9d50e5bcd49d26b',
  true
);
